module.exports = __webpack_public_path__ + "static/media/SWSCRC1-11.c8ad92e6.mp3";